import * as React from "react";
import { observer } from "mobx-react";
import { Button } from "./Button";

@observer
export class FitToWindowButton extends Button {

	render() {
		return <Button {...this.props} >
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
					<path d="M30,2v28H2V2H30 M32,0H0v32h32V0L32,0z" />
					<path d="M18,4.1l3.6,3.6l-5.5,5.5c1.2,0.7,2.1,1.7,2.8,2.8l5.5-5.5l3.6,3.6v-10H18z" />
					<path d="M14.1,28l-3.6-3.6l5.5-5.5c-1.2-0.7-2.1-1.7-2.8-2.8l-5.5,5.5L4.1,18v10H14.1z" />
				</svg>
			</i>
		</Button>;
	}
}